module["exports"] = [
  "Hr.",
  "Fr.",
  "Dr."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/name/prefix.js
// module id = 838
// module chunks = 1